module.exports = __webpack_public_path__ + "static/img/img6.dcd0766e.png";